<template>
  <div>
    <page-header
      :page="headerPage"
      :actions="headerActions"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <request-s-i-f-d-e
      v-if="showRequestSIFDE"
      v-model="requestSifdeModel"
      @submit="handlerSubmitRequest"
      @cancel="showRequestSIFDE = false"
    />
    <board class="mb-4" :details="studentBoardDetails">
      <template #data-item="{ item }">
        <div v-if="!item.data">
          <custom-balloon
            :background-color="item.statusColor"
            :text="item.statusName"
            dot
          />
        </div>
      </template>
    </board>
    <div class="mb-4">
      <q-tab :active-tab="activeTab">
        <q-tab-item
          lazy
          v-for="(tab, key) in tabs"
          :key="key"
          :title="tab.title"
          :has-error="!tab.valid"
          :visible="tab.visible"
          :nav-item-class="tab.classes"
          @click="setCurrentTab(key)"
        >
          <component
            :catalog-id="recommendation.catalogId"
            :caat-id="recommendation.referral.caatId"
            :is="tab.id"
            :ref="tab.id"
            :referral="recommendation.referral"
            :data="tab.data"
            :out-of-my-inventory="activeTab === 1"
            :recommendation="recommendation"
            @refresh="refreshPage"
          ></component>
        </q-tab-item>
      </q-tab>
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import CustomBalloon from 'custom-balloon';
import { QTab, QTabItem } from '@/components/common/q-tabs';
import mixAlert from '@/mixins/alert.mixin';
import { date } from '@/utils/filters';
import referralService from '@/services/api/referralsandequipments.api';
import MyInventory from './components/MyInventory.vue';
import RequestSIFDE from './components/RequestSIFDE.vue';

const TABS = {
  MyInventory: 0,
};

export default {
  components: {
    PageHeader,
    Board,
    CustomBalloon,
    QTab,
    QTabItem,
    MyInventory,
    RequestSIFDE,
  },
  mixins: [mixAlert],
  data: () => ({
    recommendation: { referral: {} },
    activeTab: TABS.MyInventory,
    showRequestSIFDE: false,
    requestSifdeModel: {
      comment: null,
      reason: null,
    },
  }),
  computed: {
    recommendationId() {
      return Number(this.$route.params.recommendationId);
    },
    peiAtServiceId() {
      return Number(this.$route.params.id);
    },
    headerPage() {
      return {
        icon: 'fas fa-list',
        title: `Manejo de Disponibilidad: ${this.recommendation.equipmentName}`,
        routes: [
          'Asistencia Tecnológica',
          'Manejo de Referidos y Equipos',
          'Análisis de Adquisición de Equipo',
          'Manejo de Disponibilidad',
        ],
      };
    },
    headerActions() {
      return [
        {
          text: 'Regresar',
          icon: 'far fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.go(-1),
        },
        {
          text: 'Solicitar por SIFDE',
          icon: 'far fa-plus-circle',
          variant: 'success',
          visible: !this.recommendation.purchaseMethod,
          click: () => (this.showRequestSIFDE = !this.showRequestSIFDE),
        },
      ];
    },
    studentBoardDetails() {
      return [
        [
          {
            label: 'Estudiante:',
            icon: 'fas fa-user',
            data: `${this.recommendation.referral.studentName} - ${this.recommendation.referral.studentSie}`,
            cols: 'col-12 col-md-3 pt-2',
          },
          {
            label: 'Número de Referido:',
            icon: 'fas fa-file-user',
            data: this.recommendation.referral.referralNumber || '-',
            cols: 'col-12 col-md pt-2',
          },
          {
            label: 'Fecha de Referido:',
            icon: 'fas fa-calendar-minus',
            data: date(this.recommendation.referral.referralDate),
            cols: 'col-12 col-md pt-2',
          },
          {
            label: 'CAAT:',
            icon: 'fas fa-location-dot',
            data: this.recommendation.referral.caat || '-',
            cols: 'col-12 col-md pt-2',
          },
          {
            label: 'Estatus:',
            icon: 'fas fa-file-lines',
            statusColor: this.recommendation.referral.serviceStatusColor,
            statusName: this.recommendation.referral.serviceStatusName,
            cols: 'col-12 col-md-3 pt-2',
          },
        ],
      ];
    },
    tabs() {
      return [
        {
          id: 'MyInventory',
          title: 'Mi Inventario',
          valid: true,
          visible: true,
          data: {},
        },
        {
          id: 'MyInventory',
          title: 'Fuera de mi Inventario',
          valid: true,
          visible: true,
          data: {},
        },
      ];
    },
  },
  async mounted() {
    await this.getStudentInfo();
  },
  methods: {
    async getStudentInfo() {
      const { data } = await referralService.getEquipmentRecommendationSummary(
        this.recommendationId
      );
      this.recommendation = data;
    },
    async handlerSubmitRequest() {
      try {
        const payload = {
          reasonId: this.requestSifdeModel.reason.id,
          comment: this.requestSifdeModel.comment,
          recommendationId: this.recommendationId,
        };

        await referralService.saveRecomendationRequestSidfe(payload);
        this.showRequestSIFDE = false;
        this.ShowToast(
          'Éxito',
          'Información ha sido guardada exitosamente.',
          'success'
        );
        this.$router.go(-1);
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido un error al guardar la información. Por favor, intente de nuevo.',
          'error'
        );
      }
    },
    async setCurrentTab(tab) {
      this.activeTab = tab;
    },
    async refreshPage() {
      await this.getStudentInfo();
    },
  },
};
</script>
<style lang="scss" scoped>
.fa-xlg {
  font-size: 2.5em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}
.text-gray-green {
  color: #3f5b60;
}
.text-neutral-gray {
  color: #727272;
}
.classification-item > div:last-child > span:first-child {
  font-size: 15px;
  line-height: normal;
}
.classification-item > div:last-child > span:last-child {
  font-size: 25px;
  line-height: normal;
  font-weight: 600;
}
.svg-icons {
  background-repeat: no-repeat;
  background-size: contain;
  height: 40px;
  width: 60px;
}
.svg-laptop-arrow-down-gray-green {
  background-image: url('../../../../assets/icons/laptop-arrow-down-gray-green.svg');
}
.svg-laptop-arrow-down-orange {
  background-image: url('../../../../assets/icons/laptop-arrow-down-orange.svg');
}
.svg-laptop-arrow-down-green {
  background-image: url('../../../../assets/icons/laptop-arrow-down-green.svg');
}
</style>
